/**
 * Compact USD formatter shared across the markets list view cells.
 *
 *   formatCompactUSD(0)        → "$0"
 *   formatCompactUSD(523)      → "$523"
 *   formatCompactUSD(2_400)    → "$2.4K"
 *   formatCompactUSD(8_320_000) → "$8.3M"
 *
 * `decimalsK` controls precision for the $...K bucket — table rows used
 * 1 decimal for 24h volume but 0 decimals for liquidity. Defaults to 1.
 */
export function formatCompactUSD(value: number, decimalsK: 0 | 1 = 1): string {
  const v = Number(value) || 0;
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(decimalsK)}K`;
  return `$${v.toFixed(0)}`;
}
